import React, { useEffect, useState } from "react";
import sos from "../../assets/svg/Sos.svg";
import "./Sos.css";
import axios from "axios";
import { Modal, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";

const GOOGLE_MAPS_API_KEY = "AIzaSyBxZBJZC4ABTmxiB2VUgNx2yMkUJ6s4u30"
const mapContainerStyle = {
  width: "100%",
  height: "250px",
  borderRadius: "8px",
};

export default function Sos() {
  const token = sessionStorage.getItem("token");
  const baseUrl = "https://estbn.com/EstbnNew/public/api";
  const headers = {
    Authorization: "Bearer " + token,
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  });

  const [sosRequests, setSosRequests] = useState([]);
  const [sosTypes, setSosTypes] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [sendLocation, setSendLocation] = useState(true);
  const [location, setLocation] = useState({
    lat: null,
    lng: null,
  });

  const resetForm = () => {
    setSelectedType("");
    setDescription("");
    setImage(null);
    setImagePreview(null);
    setSendLocation(true);
    setLocation({
      lat: null,
      lng: null,
    });
  };

const handleOpenModal = () => {
  resetForm();
  setShowModal(true);
  getLocation();
};

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("ar-EG", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };

  const getLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) return reject("Geolocation not supported");

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          setLocation(coords);
          resolve(coords);
        },
        (error) => reject(error),
      );
    });
  };

  const getSosRequests = async () => {
    try {
      let response = await axios.get(`${baseUrl}/stuff/sos`, {
        headers,
      });
      console.log(response.data.data.data.data);
      setSosRequests(response.data.data.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getSosTypes = async () => {
    try {
      let response = await axios.get(`${baseUrl}/stuff/get-sos-types`, {
        headers,
      });
    const rawData =
      response.data?.data && typeof response.data.data === "object"
        ? response.data.data
        : response.data;
    const types = Object.entries(rawData)
      .filter(
        ([, value]) => typeof value === "string" || typeof value === "number",
      )
      .map(([key, value]) => ({
        key,
        value: String(value),
      }));
    setSosTypes(types);
    } catch (error) {
      console.log(error);
    }
  };

  const sendSosRequest = async () => {
    try {
      const formData = new FormData();

      formData.append("type", selectedType);
      formData.append("description", description);

      if (image) {
        formData.append("image_path", image);
      }

if (sendLocation && location?.lat && location?.lng) {
        formData.append("location_lat", location.lat);
        formData.append("location_lng", location.lng);
      }

      await axios.post(`${baseUrl}/stuff/sos`, formData, {
        headers: {
          ...headers,
          "Content-Type": "multipart/form-data",
        },
      });
      setShowModal(false);
      setDescription("");
      setSelectedType("");
      setImage(null);
      getSosRequests();
      toast.success("تم ارسال طلب المساعدة بنجاح");
    } catch (error) {
      toast.error(
        error.response?.data?.errors?.message || "حدث خطأ أثناء ارسال الطلب",
      );
    }
  };

  useEffect(() => {
    if (sendLocation) {
      getLocation();
    }
  }, [sendLocation]);

  useEffect(() => {
    getSosRequests();
    getSosTypes();
  }, []);

  return (
    <section className="p-4">
      <Modal show={showModal} onHide={() => handleCloseModal()} centered>
        <Modal.Header className=" d-flex justify-content-center align-items-center bg-white">
          <Modal.Title className="text-center">طلب مساعدة</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              sendSosRequest();
            }}
          >
            {/* types */}
            <div className="mb-3 text-end">
              <label className="fw-semibold mb-2 d-block">
                : حدد نوع المشكلة
              </label>
              <div className="row d-flex justify-content-end align-items-center">
                {sosTypes.map((type) => (
                  <div key={type.key} className="col-6 mb-2">
                    <Form.Check
                      type="radio"
                      name="sosType"
                      id={type.key}
                      label={type.value}
                      checked={selectedType === type.key}
                      onChange={() => setSelectedType(type.key)}
                      className="text-end"
                    />
                  </div>
                ))}
              </div>
            </div>
            {/* description */}
            <div className="mb-3 text-end">
              <label className="fw-semibold mb-2 d-block">وصف المشكلة</label>
              <textarea
                className="form-control sos-textarea"
                rows="3"
                placeholder="اكتب أي ملاحظات عن هذا الجزء..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            {/* upload */}
            <div className="mb-3 text-end">
              <label className="fw-semibold mb-2 d-block">
                ارفع صورة توضح حالة الجزء
              </label>
              <input
                type="file"
                accept="image/*"
                id="sos-upload"
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files[0];

                  if (file) {
                    setImage(file);
                    setImagePreview(URL.createObjectURL(file));
                  }
                }}
              />

              <label htmlFor="sos-upload" className="sos-upload-box">
                {imagePreview ? (
                  <img
                    src={imagePreview}
                    alt="preview"
                    className="sos-upload-preview"
                  />
                ) : (
                  <>
                    <div className="sos-upload-icon">
                      <i className="bi bi-cloud-upload"></i>
                    </div>

                    <p className="sos-upload-title">أضف ملف</p>

                    <p className="sos-upload-sub">
                      أرفق صورة، مقطع فيديو أو تسجيل صوتي.
                    </p>
                  </>
                )}
              </label>
            </div>
              {/* location checkbox */}
            <div className="form-check d-flex justify-content-end mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                checked={sendLocation}
                onChange={() => setSendLocation(!sendLocation)}
              />

              <label className="form-check-label mx-2">
                ارسال موقعي لأستبن
              </label>
            </div>

            {/* map */}
            {sendLocation && (
              <div className="mb-4">
                <label className="fw-semibold mb-2 d-block text-end">
                  حدد موقعك ع الخريطة
                </label>
                {isLoaded && location.lat && location.lng ? (
                  <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    center={{ lat: location.lat, lng: location.lng }}
                    zoom={15}
                    onClick={(e) =>
                      setLocation({
                        lat: e.latLng.lat(),
                        lng: e.latLng.lng(),
                      })
                    }
                  >
                    <MarkerF
                      position={{ lat: location.lat, lng: location.lng }}
                      draggable
                      onDragEnd={(e) =>
                        setLocation({
                          lat: e.latLng.lat(),
                          lng: e.latLng.lng(),
                        })
                      }
                    />
                  </GoogleMap>
                ) : (
                  <p className="text-center text-muted small">
                    بنجيب موقعك الحالي...
                  </p>
                )}
              </div>
            )}
            {/* footer */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={() => setShowModal(false)}
              >
                الغاء
              </button>

              <button type="submit" className="categories_saveAddModeal">
                ارسال الطلب
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* header */}
      <div className="hp-info-card mb-4 p-4 hp-sos-card border-warning-subtle shadow-sm text-center">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <img src={sos} alt="sos" width="80" />
          <div className="text-end">
            <h4 className="fw-semibold mb-2">طلب مساعدة علي الطريق</h4>
            <p className="hp-text-muted mb-0 fs-5">
              واجهت مشكلة؟ أرسل بلّغ سريع لفريق الدعم
            </p>
          </div>
        </div>
        <button
          onClick={() => handleOpenModal()}
          className="btn btn-dark w-25 mx-auto py-2 fw-bold rounded-3"
        >
          ارسل طلب مساعدة
        </button>
      </div>
      {/* requests */}
      {sosRequests.length > 0 ? (
        sosRequests.map((request) => (
          <div
            key={request.id}
            className="hp-info-card mb-3 p-3 border-secondary-subtle shadow-sm text-end"
          >
            <h4 className="fw-bold">طلب مساعدة #{request.id}</h4>
            <h5 className="fw-semibold mb-2">{request.type}</h5>
            <p className="hp-text-muted mb-0">{request.description}</p>
            <div className="d-flex justify-content-end align-items-center mt-3">
              <p className="mx-4">{formatDate(request.created_at)}</p>

              <p>
                <a
                  href={`https://www.google.com/maps?q=${request.location_lat},${request.location_lng}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.google.com/maps{" "}
                </a>
                : اللوكيشن
              </p>
            </div>
          </div>
        ))
      ) : (
        <p className="text-center text-muted">لا توجد طلبات مساعدة</p>
      )}
    </section>
  );
}
